import {
  Button,
  ControlGroup,
  FormGroup,
  MenuItem,
  NumericInput,
} from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import {
  AnimationWipeFunction,
  type AnimationOptionWipe,
} from "@package/ui-gql/index-data-access";
import { AnimationOptionWipePreview } from "./AnimationOptionWipePreview";

type AnimationOptionWipeComponentProps = {
  disabled: boolean;
  option: AnimationOptionWipe;
  onOptionUpdated: (option: AnimationOptionWipe) => void;
};

export function AnimationOptionWipeComponent({
  disabled,
  option,
  onOptionUpdated,
}: AnimationOptionWipeComponentProps) {
  return (
    <>
      <ControlGroup fill>
        <FormGroup disabled={disabled} label="Wipe Function" fill>
          <Select<AnimationWipeFunction>
            activeItem={option.function ?? AnimationWipeFunction.Down}
            disabled={disabled}
            fill
            filterable={false}
            items={Object.values(AnimationWipeFunction)}
            itemRenderer={(type, { handleClick, handleFocus, modifiers }) => (
              <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                key={type}
                onClick={handleClick}
                onFocus={handleFocus}
                roleStructure="listoption"
                text={type}
              />
            )}
            popoverProps={{ minimal: true }}
            onItemSelect={(type) =>
              onOptionUpdated({
                ...option,
                function: type,
              })
            }
          >
            <Button
              alignText="left"
              disabled={disabled}
              minimal
              outlined
              fill
              rightIcon="caret-down"
              text={option.function ?? "Select a Function"}
            />
          </Select>
        </FormGroup>
        {!disabled && <AnimationOptionWipePreview fn={option.function} />}
      </ControlGroup>
      <FormGroup
        disabled={disabled}
        label="Wipe Duration Seconds"
        fill
        helperText="Duration of the wipe animation in seconds"
      >
        <NumericInput
          min={0}
          disabled={disabled}
          allowNumericCharactersOnly
          fill
          value={option.duration ?? 0}
          onValueChange={(duration) => {
            onOptionUpdated({
              ...option,
              duration,
            });
          }}
        />
      </FormGroup>
    </>
  );
}
